import { StoreName } from '../../constants';
import { stores } from '../../constants/stores';
import { BaseStore } from '../../types';
import { MiddlewaresList } from '../middleware/types';
import { createClientStore } from './createClientStore';
import { createServerStore } from './createServerStore';

export const createHookStore = <State>(
  // todo split static and dynamic store names and, maybe, `stores` too
  storeName: StoreName,
  initialState: State,
  middlewares?: MiddlewaresList<State>,
  init?: (args: Record<string, unknown>) => (state: State) => State
) => {
  let useIsomorphicBoundStore: BaseStore<State>;

  if (process.env.REACT_APP_ENV === 'node') {
    useIsomorphicBoundStore = createServerStore<State>(
      storeName,
      initialState,
      middlewares
    );
  } else {
    useIsomorphicBoundStore = createClientStore<State>(
      storeName,
      initialState,
      middlewares
    );
  }

  if (process.env.NODE_ENV === 'development') {
    // check if we accidentally create same store twice
    if (stores[storeName] != null) {
      throw new Error(`Duplicate store initialization detected: ${storeName}.`);
    }
  }

  // todo for some reason 'stores' is imported as undefined when running jest tests. Need to find why and remove this condition
  //  This is in fact the result of circular dependencies: solve them -> problem should go.
  if (process.env.NODE_ENV !== 'test') {
    stores[storeName] = useIsomorphicBoundStore as BaseStore<unknown>; // Typescript didn't make it here and couldn't assign State to unknown in one particular method (but could in all others)
  }

  if (init != null) {
    let wasCalled = false;
    useIsomorphicBoundStore.initialize = (args) => {
      if (wasCalled) {
        if (process.env.NODE_ENV === 'development') {
          throw new Error(`Initialize is called twice on store ${storeName}.`);
        } else {
          return;
        }
      }

      wasCalled = true;
      // init() call MUST return a function that accepts state
      useIsomorphicBoundStore.setInitialState(init(args));
    };
  }

  return useIsomorphicBoundStore as BaseStore<State>;
};
